import { render, staticRenderFns } from "./ThesisEdit.vue?vue&type=template&id=3ca485bc&scoped=true"
import script from "./ThesisEdit.vue?vue&type=script&lang=js"
export * from "./ThesisEdit.vue?vue&type=script&lang=js"
import style0 from "./ThesisEdit.vue?vue&type=style&index=0&id=3ca485bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca485bc",
  null
  
)

export default component.exports